import { useEffect, useState } from "react";
import { Documento } from "../../../Contenedores/Comun/Documento";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { TIPO_ARCHIVO_PERSONERIA_JURIDICA } from "../../../Contenedores/Comun/VARIABLES";
import ServicioComun from "../../../servicios/Comun";
import { Notificar } from "../Notificador";
import { __ConvertirABase64 } from "../../../Utils/Funciones";

function DocumentosAutorizacionAdjuntar({ clasePersona, onChangeDocumentos }) {
  const [listaDocumentos, setListaDocumentos] = useState([]);
  const [archivosSeleccionados, setArchivosSeleccionados] = useState([]);

  useEffect(() => {
    const CargarListaDocumentos = async () => {
      let tiposDocumentos =
        await ServicioAutorizaciones.ObtengaListaTiposDocumento();
      if (clasePersona === "F") {
        const index = tiposDocumentos.findIndex(
          (x) => x.codigo === TIPO_ARCHIVO_PERSONERIA_JURIDICA
        );
        tiposDocumentos.splice(index, 1);
      }

      let documentos = [];
      tiposDocumentos.forEach((item) => {
        let documento = new Documento();
        documento.TipoDocumento.Codigo = item.codigo;
        documento.TipoDocumento.Descripcion = item.descripcion;
        documentos.push(documento);
      });

      setListaDocumentos(documentos);
    };

    CargarListaDocumentos();
  }, [clasePersona]);

  const handleFileInput = async (e, documento) => {
    const archivo = e.target.files[0];
    const archivoBase64 = await __ConvertirABase64(archivo);

    documento.NombreArchivo = archivo.name;
    documento.ArchivoBase64 = archivoBase64.split(",")[1];

    const resultadoValidacion = await ServicioComun.ValidarSubidaDeDocumento([
      documento,
    ]);
    if (!resultadoValidacion.esValido) {
      Notificar("error", resultadoValidacion.errores);
      return;
    }

    ActualizarArchivosSeleccionados(documento);
    ActualizarDatosTabla(documento);
  };

  const ActualizarArchivosSeleccionados = (documento) => {
    let archivos = [...archivosSeleccionados];
    const index = archivos.findIndex(
      (x) => x.TipoDocumento.Codigo === documento.TipoDocumento.Codigo
    );
    index === -1 ? archivos.push(documento) : (archivos[index] = documento);

    setArchivosSeleccionados(archivos);
    onChangeDocumentos(archivos);
  };

  const ActualizarDatosTabla = (documento) => {
    let documentosTabla = [...listaDocumentos];
    const index = documentosTabla.findIndex(
      (x) => x.TipoDocumento.Codigo === documento.TipoDocumento.Codigo
    );
    documentosTabla[index].NombreArchivo = documento.NombreArchivo;

    setListaDocumentos(documentosTabla);
  };

  return (
    <div id="Documentos" className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Documentos</h6>
      </div>
      <div className="card-body">
        <table id="tbDocumentos" className="table table-sm">
          <thead className="table-primary">
            <tr>
              <th>Nombre </th>
              <th>Tipo Documento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {listaDocumentos.map((item, index) => (
              <tr key={index}>
                <td>{item.NombreArchivo}</td>
                <td>{item.TipoDocumento.Descripcion}</td>
                <td className="w-25">
                  <label className="btn btn-light">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileInput(e, item)}
                    />
                    <i className="fas fa-upload text-primary mr-2"></i>
                    Subir archivo
                  </label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DocumentosAutorizacionAdjuntar;
